import React from 'react';
import { Link } from '@chakra-ui/react';

export default function SpannedText({ onClick, url, children, ...rest }) {
    return (
        <>
            {' '}
            <Link
                as={url ? undefined : 'span'}
                href={url || undefined}
                target="_blank"
                onClick={onClick}
                color={'sagitarius.500'}
                cursor={'pointer'}
                {...rest}
            >
                {children}
            </Link>{' '}
        </>
    );
}
